export enum language {
  default = 'en',
}

export interface UserSettings {
  businessUnit?: string;
  inquirerCountry?: string;
  language: string;
  shipmentIdentifier?: string;
  inquirerCountryId?: string;
  error?: string;
}
